import React, {useEffect, useState} from 'react';
import useEstimateShippingMethods from "../../../hooks/useEstimateShippingMethods";
import {I18n, T} from '../../../utils/I18n/I18n';
import {GLS_PARCELLSHOP, METHOD_MATRIX, METHOD_STORE} from "../../../utils/checkout";
import CheckoutStorePickupForm from "../CheckoutStorePickupForm";
import CheckoutDeliveryForm from "../CheckoutDeliveryForm";
import GlsForm from "../GlsForm/GlsForm";
import {useQuery} from "@apollo/react-hooks";
import {STORE_LOCATIONS} from "../../../queries/misc";
import {useCartContext} from "../../../context/CartContext";

const DeliveryMethods = ({currentMethod, setMethod, pickupRef, setIsDisabled}) => {
    const {cart} = useCartContext();
    const [storeLocations, setStoreLocations] = useState([])
    const {shippingMethods} = useEstimateShippingMethods();
    const [availableShippingMethods, setAvailableShippingMethods] = useState([])
    const [carrierCodes, setCarrierCodes] = useState([])

    useQuery(STORE_LOCATIONS, {
            variables: {
                cart_id: cart.id.toString()
            },
            fetchPolicy: 'no-cache',
            ssr: true,
            onCompleted: data => {
                setStoreLocations(data.storeLocations)
            }
        }
    );

    const setMethodHandle = (metod) => {
        if (carrierCodes.includes(metod)) {
            setMethod(metod)
        }
    }

    useEffect(() => {

    }, [currentMethod])

    useEffect(() => {

        if (shippingMethods) {
            const uniqueCarrierCodes = [];
            const uniqueShippingMethods = shippingMethods.filter((method) => {
                if (!uniqueCarrierCodes.includes(method.carrierCode)) {
                    uniqueCarrierCodes.push(method.carrierCode);
                    return true;
                }
                return false;
            });
            setAvailableShippingMethods(uniqueShippingMethods)
            setCarrierCodes(uniqueCarrierCodes)
        }
    }, [shippingMethods])

    let clasess = ['shipping-method']

    return (
        <>
            <div className="checkout__main__methods">
                {

                    availableShippingMethods.map((method) => {
                        if (method.carrierCode == METHOD_STORE && storeLocations.length == 0) {
                            return false
                        }
                        clasess = ['shipping-method', method.carrierCode];
                        if (method.carrierCode == currentMethod) {
                            clasess.push('selected')
                        }
                        return (
                            <div
                                id={method.carrierCode}
                                key={method.carrierCode}
                                onClick={() => setMethodHandle(method.carrierCode)}
                                className={clasess.join(' ')}>
                                <div className='wrapper'>
                                    <div className="ico"/>
                                    <I18n>
                                        {t => (
                                            <div className="name shipping-method__text uppercase">
                                                <T id={['cartSummary', method.carrierCode].join('.')}/>
                                            </div>
                                        )}
                                    </I18n>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
            <div className="checkout__main__method-message">
                {currentMethod === METHOD_STORE && (
                    <span>
              <T id="cartSummary.freeOnHandDelivery"/>{' '}
                        <strong>
                <T id="cartSummary.checkoutFreeDelivery"/>
              </strong>
              .
            </span>
                )}
                {currentMethod === METHOD_MATRIX && (
                    <span>
              <T id="cartSummary.priceDependsOnDelivery"/>
            </span>
                )}
            </div>
            <div className="checkout__main__form">
                {currentMethod === METHOD_STORE && carrierCodes.includes(currentMethod) &&
                    <CheckoutStorePickupForm ref={pickupRef} setIsDisabled={setIsDisabled}
                                             storeLocations={storeLocations}/>}
                {currentMethod === METHOD_MATRIX && carrierCodes.includes(currentMethod) &&
                    <CheckoutDeliveryForm setIsDisabled={setIsDisabled}/>}
                {currentMethod === GLS_PARCELLSHOP && carrierCodes.includes(currentMethod) &&
                    <GlsForm ref={pickupRef} setIsDisabled={setIsDisabled}
                    method={availableShippingMethods.find((method)=>{
                        return method.carrierCode==GLS_PARCELLSHOP
                    })}
                    />

                }
            </div>
        </>
    )
}

export default DeliveryMethods